/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Polyfill
 ---------------------------------------------------------- */
import './polyfill/_custom-event'
import './polyfill/_for-each'

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import VideoModal from 'modules/_video-modal'
import LazyLoad from 'modules/_lazy-load'
import ProductSlider from 'modules/_product-slider'
import ArticleSliders from 'modules/_article-sliders'
import LoadMore from 'modules/_load-more'
import SmoothScroll from './modules/_smooth-scroll'
import GallerySliders from './modules/_gallery-sliders'
import OccasionSliders from './modules/_occasion-sliders'
import TabsWidget from './modules/_tabs-widget'
import HedgePlant from './modules/_hedge-plant'
import Cart from './modules/_cart'
import MiniCartHandler from './modules/_mini_cart_handler'
import PlantGuide from './modules/_plant-guide'
import InstagramFeed from './modules/_instagram-feed'
import VariationsHandler from './modules/_variations_handler'
import Tooltip from './modules/_tooltip'
import Postfix from './modules/_postfix'
import FloatingLabels from './modules/_floating-labels'
import CoverGallery from './modules/_cover-gallery'
import CartHandler from './modules/_cart_handler'
import Modal from './modules/_modal'
import SingleProductHandler from './modules/_single_product_handler'
import TextAccordion from './modules/_text-accordion'
import VideoBanners from './modules/_video-banners'
import ModalOrder from './utils/_model-order-adjust-height-ios'
import MttProductGallery from 'modules/_mtt-product-gallery'
import TabsVariationsHandler from 'modules/_tabs-variations-handler'
import CheckoutShippingModal from 'modules/_checkout-shipping-modal'
import CheckoutHandler from 'modules/_checkout-handler'
import callMeUpModal from 'modules/_call-me-up-modal'
import GA4TrackingHandler from 'app/GA4/_ga4-tracking-handler'
import linkBoxesSlider from "modules/_link-boxes-slider";

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(VideoModal)
app.use(LazyLoad)
app.use(ProductSlider)
app.use(ArticleSliders)
app.use(LoadMore)
app.use(SmoothScroll)
app.use(GallerySliders)
app.use(OccasionSliders)
app.use(TabsWidget)
app.use(Cart)
app.use(MiniCartHandler)
app.use(InstagramFeed)
app.use(Tooltip)
app.use(Postfix)
app.use(FloatingLabels)
app.use(CoverGallery)
app.use(CartHandler)
app.use(Modal)
app.use(TextAccordion)
app.use(VideoBanners)
app.use(PlantGuide)
app.use(ModalOrder)
app.use(CheckoutShippingModal)

// app.use(HedgePlant)
// app.use(VariationsHandler)
app.use(SingleProductHandler)
app.use(MttProductGallery)
app.use(TabsVariationsHandler)
app.use(CheckoutHandler)
callMeUpModal()

app.use(GA4TrackingHandler)
linkBoxesSlider()
require('./app')
